import { render, staticRenderFns } from "./BadgeSetup.vue?vue&type=template&id=a64dafea&scoped=true&"
import script from "./BadgeSetup.vue?vue&type=script&lang=js&"
export * from "./BadgeSetup.vue?vue&type=script&lang=js&"
import style0 from "./BadgeSetup.vue?vue&type=style&index=0&id=a64dafea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64dafea",
  null
  
)

export default component.exports